"use client";

import { GET_TESTIMONIALS_BY_SLUG } from "@/graphql/queries/testimonials-by-slug-query";
import { useSuspenseQuery } from "@apollo/client/react";
import { useParams } from "next/navigation";
import { Marquee } from "../ui/marquee";
import { TestimonialCard } from "./testimonial-card";
type Params = {
  country?: string;
  slug?: string;
  course?: string;
  category?: string;
};

export const LearnersContent = () => {
  const { country, slug, course, category } = useParams<Params>();

  const { data } = useSuspenseQuery(GET_TESTIMONIALS_BY_SLUG, {
    variables: { slug: course || category || slug, country },
  });

  if (!data) return null;
  return (
    <Marquee pauseOnHover>
      {data.testimonialsBySlug.map((testimonial) => (
        <TestimonialCard
          key={testimonial.id}
          avatar={testimonial.avatar_img}
          name={testimonial.userName}
          company={testimonial.companyName}
          quote={testimonial.comments}
          rating={testimonial.fiveStarRating}
          role={testimonial.jobTitle}
          truncateInSlider
        />
      ))}
    </Marquee>
  );
};
